import { TimeBasedSettingBaseDtoImpl, TimeBasedSettingBaseDto } from './timebasedsettingbasedto';

export interface TimeBasedSettingForSpecificCallerDto extends TimeBasedSettingBaseDto
{
    getPackName(): string;
    getBPartyMsisdn(): string;
}

export class TimeBasedSettingForSpecificCallerDtoImpl extends TimeBasedSettingBaseDtoImpl implements TimeBasedSettingForSpecificCallerDto
{
    private packName: string;
    private bPartyMsisdn: string;

    setPackName(packName: string)
    {
        this.packName = packName;
    }
    getPackName(): string 
    {
        return this.packName;
    }

    setBPartyMsisdn(bPartyMsisdn: string)
    {
        this.bPartyMsisdn = bPartyMsisdn;
    }
    getBPartyMsisdn(): string 
    {
        return this.bPartyMsisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/timebasedsetting/timebasedsettingforspecificcallerdto.tsx